module.exports = "../../../../platform/assets/pageMainIcon/cd-status-1.svg";